import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_breakdown_possible_across_types_social_insurance_total_1'

export const dataPointDefinition = {
  retracedId: 'no_breakdown_possible_across_types_social_insurance_total_1',
  name: 'No breakdown possible across types of social insurance AND total worker contribution amount NOT collected and/ or forwar',
  description: 'Select this item if it is:',
  meta: {
    slcpMeta: {
      key: 'wb-wage-105x',
      number: 'WB-WAGE-123-7',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-105x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35950,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
